import { IOrganizationAccount, IOrganizationItem } from "model/organizations";

export function getAllowedAccounts(
  allAccounts: IOrganizationAccount[] | undefined,
  canAccessAnyAccount: boolean | undefined,
  userAccessibleAccountIds: string[] | undefined
) {
  if (canAccessAnyAccount) {
    return allAccounts;
  }
  if (!userAccessibleAccountIds?.length || !allAccounts?.length) {
    return [];
  }
  return allAccounts.filter((acc) => userAccessibleAccountIds.includes(acc.id));
}

export const getOrgsWithAllowedAccounts = (
  orgs: IOrganizationItem[],
  canAccessAnyAccount: boolean | undefined,
  userAccessibleAccountIds: string[] | undefined
) => {
  if (canAccessAnyAccount) return orgs;

  return orgs.map((org) => ({
    ...org,
    accounts: getAllowedAccounts(org.accounts, false, userAccessibleAccountIds),
  }));
};
